import axiosInstance from '@/services/api';
import { Entity, EntityImageUpload, EntityResponse, UploadImageResponse } from '@/types/entityType';
import { getToken } from '@/utils/handleToken';

const ENTITY_API_URL = '/master/entity';

// const token = getToken(); 

export const fetchEntities = async (): Promise<EntityResponse> => {
	const token = getToken();
	try {
		const response = await axiosInstance.get(`${ENTITY_API_URL}/list`, {
			headers: {
				Authorization: `${token}`,
			},
		});
		return response.data;
	} catch (error: any) {
		throw new Error(
			error.response?.data?.message || 'Gagal mengambil data entity'
		);
	}
};

export const updateEntity = async (data: Entity): Promise<EntityResponse> => {
	const token = getToken();
	try {
		const response = await axiosInstance.post(
			`${ENTITY_API_URL}/update`,
			data,
			{
				headers: {
					Authorization: `${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return response.data;
	} catch (error: any) {
		throw new Error(
			error.response?.data?.message || 'Gagal memperbarui entity'
		);
	}
};

export const uploadEntityImage = async (
	data: EntityImageUpload,
	uploadType: 'sm' | 'md' | 'bg'
): Promise<UploadImageResponse> => {
	const token = getToken();
	try {
		const response = await axiosInstance.post(
			`${ENTITY_API_URL}/upload-image`,
			data,
			{
				headers: {
					Authorization: `${token}`,
					'Content-Type': 'application/json',
					upload_type: uploadType,
				},
			}
		);
		return response.data;
	} catch (error: any) {
		throw new Error(error.response?.data?.message || 'Gagal mengupload gambar');
	}
};
